import properCase from './formatProperCase';
import date, { toMoment } from './formatDate';
import phone from './formatPhone';
import numbersOnly from './formatNumbersOnly';

export default {
	date: date,
	phone: phone,
	properCase: properCase,
	numbersOnly: numbersOnly,
	toMoment: toMoment
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@allpro/form-manager/es/formatters/index.js
// module id = 88
// module chunks = 0